<template>
  <div class="admin-dom-wrapper">
    <admin-nav active="profil" />
    <b-container fluid>
      <b-row>
        <b-col md="6">
          <b-card>
            <h4 class="mb-2">
              Mon profil
            </h4>
            <p v-if="admin">
              <strong>Nom :</strong> {{ admin.prenom }} {{ admin.nom }}<br>
              <strong>Email :</strong> {{ admin.email }}<br>
              <strong>Rôle :</strong>
              <b-badge :variant="admin.superadmin ? 'danger' : 'primary'">
                {{ admin.superadmin ? 'Superadmin' : 'Admin' }}
              </b-badge>
            </p>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card>
            <h4 class="mb-2">
              Changer mon mot de passe
            </h4>
            <b-form @submit.prevent="changer">
              <b-form-group label="Mot de passe actuel">
                <b-form-input
                  v-model="oldPassword"
                  type="password"
                  required
                />
              </b-form-group>
              <b-form-group label="Nouveau mot de passe (8+ caractères)">
                <b-form-input
                  v-model="newPassword"
                  type="password"
                  required
                  minlength="8"
                />
              </b-form-group>
              <b-form-group label="Confirmation">
                <b-form-input
                  v-model="confirm"
                  type="password"
                  required
                  minlength="8"
                />
              </b-form-group>
              <b-alert
                v-if="error"
                variant="danger"
                show
              >
                {{ error }}
              </b-alert>
              <b-button
                type="submit"
                variant="primary"
                :disabled="loading"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                <span v-else>Enregistrer</span>
              </b-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BSpinner, BAlert, BBadge, BContainer,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AdminNav from './AdminNav.vue'

export default {
  components: {
    BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BSpinner, BAlert, BBadge, BContainer, AdminNav,
  },
  data() {
    return {
      admin: null,
      oldPassword: '',
      newPassword: '',
      confirm: '',
      loading: false,
      error: '',
    }
  },
  created() {
    const raw = localStorage.getItem('domAdminData')
    if (raw) this.admin = JSON.parse(raw)
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    changer() {
      this.error = ''
      if (this.newPassword !== this.confirm) {
        this.error = 'Les mots de passe ne correspondent pas'
        return
      }
      this.loading = true
      this.$http.post('/admindom/changepassword', {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      }, this.authHeaders())
        .then(response => {
          this.loading = false
          if (response.data.res === 1) {
            this.oldPassword = ''
            this.newPassword = ''
            this.confirm = ''
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: { title: 'Mot de passe modifié', variant: 'success', icon: 'CheckCircleIcon' },
            })
          } else {
            this.error = response.data.message || 'Erreur'
          }
        })
        .catch(() => {
          this.loading = false
          this.error = 'Erreur serveur'
        })
    },
  },
}
</script>

<style lang="scss">
.admin-dom-wrapper {
  min-height: 100vh;
  background-color: #f8f8f8;
  padding-bottom: 2rem;
}
</style>
